import { render, staticRenderFns } from "./latestComments.vue?vue&type=template&id=1fbc8518&"
import script from "./latestComments.vue?vue&type=script&lang=js&"
export * from "./latestComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports